module.exports = __webpack_public_path__ + "img/荣誉证书1.4df062e4.png";